import { render, staticRenderFns } from "./KPage.vue?vue&type=template&id=86ef629a&"
import script from "./KPage.vue?vue&type=script&lang=js&"
export * from "./KPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports